import React,{useState,useEffect} from 'react'
import SubHeader from '../../layout/components/SubHeader'
import { useParams } from 'react-router-dom'
import MiniCalendar from './MiniCalendar';
import ActivityHeader from './ActivityHeader';
import ActivityNav from './ActivityNav';
import Pagination2 from '../../common/Pagination2';
import clinicService from '../../../services/clinic.service';
import { useEyeconxStore } from '../../../store/eyeconxStore';
import ActivityList from './ActivityList';
function MyActivity() {
  const {type} = useParams();
  const {activityParamDate} = useParams();
  const [activityType,setActivityType] = useState(type);
  const [activityList,setActivityList] = useState([]);
  //set activitydate to todays date by default and format is 2024-08-21
  const [currentPage,setCurrentPage] = useState(0)
  const [itemsPerPage,setItemsPerPage] = useState(10)
  const [totalPages,setTotalPages] = useState(0)

  const [activityDate,setActivityDate] = useState(new Date().toISOString().slice(0, 10));
  //todays date in format 2024-08-21
  const today = new Date().toISOString().slice(0, 10);
  const user = useEyeconxStore((state) => state.user);



  useEffect(()=>{
    console.log("Activity Type in useEffect: "+activityType);
    if(activityParamDate === undefined){
      setActivityDate(today);
      getActivityList(currentPage,itemsPerPage,today);
    }else{
      setActivityDate(activityParamDate);
      getActivityList(currentPage, itemsPerPage, activityParamDate);
    }
   setActivityType(type)
  },[type,activityParamDate,currentPage,itemsPerPage])

  
  const getActivityList = (pg_no,pg_size,act_date)=>{
      const myquery = activityTypeQuery() + "date:"+act_date
      console.log(myquery);
      clinicService.getActivity(user.clinicId,pg_no,pg_size,myquery).then((res)=>{
        setActivityList(res.data.content);
        setTotalPages(res.data.totalPages);
        
        console.log(res.data.content);
      })
      .catch((err)=>{
        //console.log(err);
        //check if error status is 404 
        if(err.response.status === 404){
          setActivityList([]);
        }
        console.log(err)
      })
  }

  const paginate = (pageNumber)=>{
    setCurrentPage(pageNumber);
  }
  const activityTypeQuery = ()=>{
    console.log("Activity Type in query: "+activityType);
    switch(activityType){
      case 'reminders':
        return 'reminders:all,';
      case 'recalls':
        return 'recalls:all,';
      case 'optical-lab':
        return 'optical-lab:all,';
      case 'summary':
        return 'summary:all,';
      case 'thank-you':
        return 'thank-you:all,';
      case 'confirmations':
        return 'confirmations:all,';
      case 'welcome':
        return 'reminderType:18,';
      case 'birthday':
        return 'reminerType:19,';
      default:
        return '';
    }
  }

  const NoActivity = ()=>{
    return (
      <div className="alert alert-info d-flex align-items-center p-5">
        <div className="bi bi-info-circle-fill flex-shrink-0 me-3" style={{fontSize: '2rem'}}></div>
        <div>
          <h2 className="mb-1">No Activity Found</h2>
          <span>There is no activity for the selected date.</span>
        </div>
      </div>
    )
  }
  return (
    <>
   <ActivityHeader activityType= {activityType} activityDate={activityDate} />
    <div className='app-container container-xxl'>
         <div className="row">
            <div className="col-3">
                <div className="card">
                  <div className="card-body">
                    <ActivityNav activityType={activityType} activityDate={activityDate}/>
                  </div>
                </div>
            </div>
            <div className="col-9">
                <div className="card">
                  <div className="card-body">
                     
                     {activityList.length > 0 ?<ActivityList 
                          activityList = {activityList} 
                          activityDate = {activityDate}
                          activityType = {activityType}
                          pageSize = {itemsPerPage}
                          currentPage = {currentPage}
                          totalPages = {totalPages}
                          paginate = {paginate}

                          
                          /> : <NoActivity/>}
                  </div>
                </div>
            </div>
         </div>
       
      
    </div>
</>
  )
}

export default MyActivity